module.exports = __webpack_public_path__ + "static/media/home-events-cursor.bb0a0606.svg";